import { Box, Button, Grid, Modal, TextField, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { deleteCompanyLeave } from 'src/services/yearPlannerService';
import { AppActions } from 'src/store/AppReducer';

interface Props {
  show: boolean;
  handleClose: () => void;
  date: any;
  holidayType: any;
  id: string;
}

const DeleteLeaveModal = (props: Props) => {
  const [showModal, setShowModal] = useState(false);
  const dispatch = useDispatch();

  const deleteLeave = () => {
    dispatch(AppActions.toggleSnackBarClose());

    deleteCompanyLeave(props.id)
      .then((res) => {
        handleClose();
        dispatch(
          AppActions.toggleSnackBarOpen({
            message: 'Holiday Deleted Successfully',
            severity: 'success'
          })
        );
      })
      .catch((e) => {
        handleClose();
        dispatch(
          AppActions.toggleSnackBarOpen({
            message: 'Unable To Delete the Holiday',
            severity: 'error'
          })
        );
      });
  };

  useEffect(() => {
    if (props.show) {
      setShowModal(props.show);
    }
  }, [props.show]);

  const handleClose = () => {
    setShowModal(false);
    props.handleClose();
  };
  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    width: window.innerWidth <= 990 ? 400 : 600,
    transform: 'translate(-50%, -50%)',
    bgcolor: 'background.paper',
    border: '0px',
    boxShadow: 24,
    p: 4
  };
  return (
    <Modal
      open={showModal}
      onClose={handleClose}
      onBackdropClick={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <Typography id="modal-modal-title" variant="h5" component="h2">
          Delete Holiday
        </Typography>
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          spacing={1}
          columnSpacing={{ xs: 1, sm: 1, md: 1, lg: 2 }}
        >
          <Grid xs={12} md={12}>
            <p style={{ marginLeft: 15, marginTop: 15 }}>
              Are you sure you want to delete this holiday?
            </p>
          </Grid>
          <Grid
            container
            direction="row-reverse"
            justifyContent="end"
            alignItems="center"
            spacing={1}
          >
            <Grid>
              <Button
                sx={{ mx: 1 }}
                variant="contained"
                color="primary"
                onClick={deleteLeave}
              >
                Yes
              </Button>
            </Grid>
            <Grid>
              <Button onClick={handleClose}>No</Button>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </Modal>
  );
};
export default DeleteLeaveModal;
